var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCafr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#2B63D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 5L8 3L9.5 5L8.5 9.5V10H9.00024C9.00024 8.31201 9.73005 7 10.659 7C12.046 7 12.4175 10 11.4884 10C10.8589 10 10.8516 9.61594 10.8443 9.2365C10.8371 8.86605 10.8301 8.5 10.2443 8.5C10.0233 8.5 9.41494 8.53294 9.41494 10H10.5V11H8.5V11.5H9V12.5H8.5V13H7.5V12.5H7V11.5H7.5V11H5.5V10H6.58506C6.58506 8.53294 5.97667 8.5 5.75566 8.5C5.16989 8.5 5.16285 8.86605 5.15574 9.2365C5.14845 9.61594 5.14107 10 4.51155 10C3.58252 10 3.95404 7 5.34096 7C6.26995 7 6.99976 8.31201 6.99976 10H7.5V9.5L6.5 5Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8C15.75 12.2802 12.2802 15.75 8 15.75C3.71979 15.75 0.25 12.2802 0.25 8C0.25 3.71979 3.71979 0.25 8 0.25C12.2802 0.25 15.75 3.71979 15.75 8Z",
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })));
}

export default SvgCafr;